:root {
  --duration: 800ms;
}

.background {
  position: relative;
  transition-property: background-color, width;
  transition-duration: var(--duration);
  background-color: var(--mantine-color-gray-2);
}

.innerContainer {
  position: relative;
  transition-property: width;
  transition-duration: var(--duration);
}

.leftTile {
  position: absolute;
  left: 8px;
  transition-property: opacity;
  transition-duration: var(--duration);
}

.arrow {
  transition-property: opacity;
  transition-duration: var(--duration);
}

.rightTile {
  position: absolute;
  right: 8px;
}

.userIcon,
.checkIcon {
  transition-property: opacity;
  transition-duration: var(--duration);
}
